--------README --------------------------------------------------------------------------------
ici des commentaires liées au composant
------------------------------------------------------------------------------------------------

<template>

	<div :class="{'menu-isOpen' : isOpen}" class="menu">
		<div class="menu_btn">
			<ButtonBurger :isOpen="isOpen" @click.native="toggleClick"></ButtonBurger>
		</div>

		<!--        <div class="menu_nav menu_nav-left" @click="prev()" :class="{'menu_nav-disabled' : (currentItem === 0)}">-->
		<!--            <FaIcon name="chevron-left" />-->
		<!--        </div>-->
		<!--        <div class="menu_nav menu_nav-right" @click="next()" :class="{'menu_nav-disabled' : (currentItem === this.menuItems.length - 1)}">-->
		<!--            <FaIcon name="chevron-right" />-->
		<!--        </div>-->

		<div ref="menu_panel" class="menu_panel">
			<div ref="menu_panelInner" v-hammer:swipe.horizontal="onSwipe" class="menu_panelInner">
				<a v-for="(item, index) in menuItems"
				   ref="menu_item"
				   :class="{'menu_item-dark': item.theme, 'menu_item-imageBottom': item.imageBottom, 'menu_item-active': (index === currentItem)}"
				   :data-index="index"
				   :data-intro="item.intro"
				   :data-segment="$t(`menu.${item.pageComponent}.segment`)"
				   :href="$t(`menu.${item.pageComponent}.segment`)+'/index.html'"
				   class="menu_item"
				   @click.prevent="clickOnMenuItem(item)"
				>
					<div v-if="item.image" :style="{'background-color': item.color}" class="menu_item_content">
						<div class="menu_item_imageWrapper">
							<div
									:style="{'background-image': 'url(' + imgPath(item.image) + ')', 'background-size': item.imageScale, 'background-position': item.imageOffset}"
									class="menu_item_image"></div>
						</div>
						<div v-if="item.layoutColor" :style="{'background-color': item.layoutColor, 'z-index': item.layoutIndex}"
						     class="menu_item_layout"></div>
						<div v-if="item.layoutImage" :style="{'background-image': item.layoutImage, 'z-index': item.layoutIndex}"
						     class="menu_item_layout"></div>
						<div class="menu_item_label">
							<span v-html="$t(`menu.${item.pageComponent}.headTitle`)"></span>
							<span v-html="$t(`menu.${item.pageComponent}.title`)"></span>
							<span v-if="item.tag" class="menu_item_tag">
								<svg id="Calque_1" style="enable-background:new 0 0 18 19;" version="1.1"
								     viewBox="0 0 18 19" x="0px" xml:space="preserve"
								     xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" y="0px">
									<g>
										<g>
											<path d="M9,18c-4.7,0-8.5-3.8-8.5-8.5C0.5,4.8,4.3,1,9,1c4.7,0,8.5,3.8,8.5,8.5C17.5,14.2,13.7,18,9,18z M9,1.9
												c-4.2,0-7.6,3.4-7.6,7.6c0,4.2,3.4,7.6,7.6,7.6c4.2,0,7.6-3.4,7.6-7.6C16.6,5.3,13.2,1.9,9,1.9z"/>
										</g>
										<g>
											<path d="M9,15.9c-3.5,0-6.4-2.9-6.4-6.4C2.6,6,5.5,3.1,9,3.1s6.4,2.9,6.4,6.4C15.4,13,12.5,15.9,9,15.9z M9,4C6,4,3.5,6.5,3.5,9.5
												C3.5,12.5,6,15,9,15s5.5-2.5,5.5-5.5C14.5,6.5,12,4,9,4z"/>
										</g>
										<g>
											<path d="M9,13.8c-2.4,0-4.3-1.9-4.3-4.3S6.6,5.2,9,5.2c2.4,0,4.3,1.9,4.3,4.3S11.4,13.8,9,13.8z M9,6.1c-1.9,0-3.4,1.5-3.4,3.4
												c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4C12.4,7.6,10.9,6.1,9,6.1z"/>
										</g>
									</g>
								</svg>
								<span v-html="$t('tagTheme')"></span>
							</span>
						</div>
					</div>
					<div v-else="item.image"
					     :style="{'background-color': item.layoutColor, 'background-image': item.layoutImage,}"
					     class="menu_item_content">
						<div :style="{'background-color': item.color}" class="menu_item_label"
						     v-html="$t(`menu.${item.pageComponent}.title`)"></div>
					</div>
					<ReadingTime v-if="item.wordsCount" :isSeen="isSeen($t(`menu.${item.pageComponent}.segment`))"
					             :wordsCount="item.wordsCount"
					             class="menu_item_readingtime"></ReadingTime>
				</a>
			</div>
		</div>

		<div ref="menu_transition" :class="{'-visible': transitionVisible}" class="menu_transition">
			<div ref="menu_transition_img"
			     :style="{'background-image': 'url(' + imgPath(transitionImg) + ')', 'background-size': transitionImageScale, 'background-position': transitionImageOffset}"
			     class="menu_transition_img">
			</div>
			<div ref="menu_transition_text" :style="{'background-color': transitionLayoutColor}" class="menu_transition_text">
				<span v-html="transitionHeadTitle"></span>
				<span v-html="transitionTitle"></span>
			</div>
		</div>

	</div>

</template>

<script>
import $ from "jquery";
import {EMenuIntro} from "@/constants/conf";
import {TimelineMax, TweenMax} from "gsap";
import ButtonMagnetic from "./ButtonMagnetic.vue";
import {Locales} from "../plugin/Locales";
import ButtonBurger from "./ButtonBurger";
import FaIcon from "./FaIcon.vue";
import {Device, EBreakPoint} from "../utils/Device";
import {debounce} from "debounce";
import {i18n} from "../plugin/i18n";
import ReadingTime from "@/components/ReadingTime.vue";


export default {
	name: "Menu",
	components: {ReadingTime, FaIcon, ButtonBurger, ButtonMagnetic},
	data() {
		return {
			isOpen: false,
			TL_menu: false,
			transitionVisible: false,
			menuItems: [],
			currentItem: 0,
			transitionLayoutColor: "white",
			transitionHeadTitle: "",
			transitionTitle: "",
			transitionImg: "",
			transitionImageScale: "",
			transitionImageOffset: ""
		};
	},
	watch: {
		$route: function () {
			this.close();
		}
	},
	mounted() {
		// on recupere les entrées du menu via notre objet de trad
		this.menuItems = Locales.mainMenu;
		// on ecoute un evenement (possibilité d'ouvrir le menu depuis d'autre composants)
		this.$events.on("menu-openSummary", () => {
			this.open();
		});
		this.$events.on("pageTransitionEnterDone", () => {
			this.hideTransition();
		});
		// window.onresize = debounce( () => {this.init();}, 200);
		// on configure les propriete pour notre menu (pour la navigation)
		//this.init();


	},
	updated() {
		this.init();
	},
	methods: {
		init() {
			// TweenMax.set(this.$refs.menu_overlay, {yPercent: -100});
			// TweenMax.set(this.$refs.menu_panelInner, {yPercent: -100});
		},
		clickOnMenuItem(item) {

			this.transitionImg = item.image;
			this.transitionImageScale = item.imageScale;
			this.transitionImageOffset = item.imageOffset;
			this.transitionHeadTitle = this.$t(`menu.${item.pageComponent}.headTitle`);
			this.transitionTitle = this.$t(`menu.${item.pageComponent}.title`);
			this.transitionLayoutColor = item.color;
			const segment = this.$t(`menu.${item.pageComponent}.segment`);

			// // pas de clic si on est sur la page courante
			if ("page" in this.$route.params) {
				if (this.$route.params.page === segment) {
					// on remet le scroll de la page en haut
					$(".pageSelector .page").scrollTop(0);
					// on ferme le menu
					this.close();
					return;
				}
			}

			// on va récupérer tous les éléments du menu sauf celui cliqué
			if (Device.isUpTo(EBreakPoint.SM)) {
				// let $items = $('.menu_item').not($item);
				// TweenMax.to($items, 1, {
				//   alpha: 0, onComplete: () => {
				//     this.$router.push({name: 'page', params: {page: $item.data('segment')}});
				//   }
				// });
			}


			switch (item.intro) {
				case EMenuIntro.DEFAULT :
					this.$router.push({name: "page", params: {page: segment}});
					break;
				case EMenuIntro.ARTICLE :
					this.launchIntroArticle(segment);
					break;
				default :
					this.$router.push({name: "page", params: {page: segment}});
					break;
			}

			// TweenMax.staggerTo($items, 0.5, {y: -10, alpha: 0, ease: Expo.easeInOut}, 0.05, () => {
			//   this.$router.push({ name: 'page', params: { page: $item.data('segment') }});
			// });
		},
		launchIntroArticle(segment) {
			this.showTransition();

			if (Device.isUpTo(EBreakPoint.SM)) {
				let t = new TimelineMax();
				t.add([
					TweenMax.fromTo(".menu_transition_img", 1.5, {xPercent: 0}, {xPercent: 100, ease: Expo.easeInOut}),
					TweenMax.fromTo(".menu_transition_text", 1.5, {xPercent: 0}, {xPercent: 200, ease: Expo.easeInOut}),
					TweenMax.fromTo(".menu_transition_text span", 1.5, {x: -75}, {delay: 0.25, x: 0, ease: Expo.easeInOut})
				]);
				t.add(() => {
					this.$router.push({name: "page", params: {page: segment}});
				});

			} else {
				let t = new TimelineMax();
				t.add([
					TweenMax.to(".menu_transition_img", 1, {
						ease: Expo.easeInOut,
						clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
					}),
					TweenMax.to(".menu_transition_text", 1, {
						ease: Expo.easeInOut,
						clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
					})
				]);
				t.add(() => {
					this.$router.push({name: "page", params: {page: segment}});
				});
			}
		},
		onSwipe(event) {
			if (event.direction === 2) {
				this.next();
			} else if (event.direction === 4) {
				this.prev();
			}
		},
		next() {
			if (this.currentItem < (this.menuItems.length - 1)) {
				this.currentItem += 1;
				this.move();
			}
		},
		prev() {
			if (this.currentItem > 0) {
				this.currentItem -= 1;
				this.move();
			}
		},
		move() {
			let wpWidth = Device.vp.w * 0.7;
			let offset = (this.currentItem) * (wpWidth); // 40 correspond au gap entre les items
			TweenMax.to(this.$refs.menu_panelInner, 0.3, {
				x: -offset,
				ease: Expo.ease
			});
		},
		toggleClick() {
			if (this.isOpen) {
				this.close();
			} else {
				this.open();
			}
		},
		reset() {
			// on repositionne le containter sur les premier éléménts
			TweenMax.set(this.$refs.menu_panelInner, {x: 0});
			TweenMax.to($(".menu_item"), 1, {alpha: 1});
			this.currentItem = 0;
		},
		open() {
			this.isOpen = true;
			this.$events.fire("menu-isOpening");
			this.reset();

			if (this.TL_menu) {
				this.TL_menu.pause();
			}
			this.TL_menu = new TimelineMax({
				onComplete: () => {
					this.$events.fire("ButtonMagneticUpdate");
				}
			});
			this.TL_menu.set(this.$refs.menu_panel, {visibility: "visible"});

			this.TL_menu.add([
				TweenMax.to(this.$refs.menu_panel, 0.5, {yPercent: 100, Ease: Expo.easeInOut}),
				TweenMax.to(this.$refs.menu_panelInner, 0.6, {delay: 0.4, y: 0, Ease: Expo.easeInOut})
			]);
			$("body").addClass("menu-open");

		},
		close() {
			this.isOpen = false;
			this.$events.fire("menu-isClosing");
			if (this.TL_menu) {
				this.TL_menu.pause();
			}
			this.TL_menu = new TimelineMax();
			this.TL_menu.add([
				TweenMax.to(this.$refs.menu_panel, 0.5, {yPercent: 0, ease: Expo.easeInOut}),
				TweenMax.to(this.$refs.menu_panelInner, 0.4, {y: -0.2 * Device.vp.h, Ease: Expo.easeInOut})
			]);
			this.TL_menu.set(this.$refs.menu_panel, {visibility: "hidden"});
			$("body").removeClass("menu-open");
		},
		showTransition() {
			if (!Device.isUpTo(EBreakPoint.SM)) {
				TweenMax.set(".menu_transition_img", {clipPath: "polygon(15% 35%, 85% 35%, 85% 100%, 15% 100%)"});
				TweenMax.set(".menu_transition_text", {clipPath: "polygon(15% 0%, 85% 0%, 85% 65%, 15% 65%)"});
			}
			this.transitionVisible = true;

		},
		hideTransition() {
			this.transitionVisible = false;
		},
		imgPath(image) {
			if (image) {
				return require("../assets/img/" + image);
			}
		},
		isSeen(segment) {
			let pageSeen = JSON.parse(localStorage.getItem("pagesSeen"));
			if (pageSeen) {
				return pageSeen.includes(segment);
			} else {
				return false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>

.menu {

	width: 100%;
	height: dvh(100);
	overflow: hidden;
	position: absolute;
	top: 0;
	left: 0;

	&_btn {
		position: fixed;
		right: 0.5rem;
		top: 0.5rem;
		z-index: $ZI-menuBtn;
		cursor: pointer;
		@include transition();
	}

	&_nav {
		position: fixed;
		top: 50vh;
		z-index: $ZI-menuBtn;
		width: 2rem;
		color: #ffffff;
		opacity: 1;
		cursor: pointer;
		padding: $G-default / 2;
		box-sizing: content-box;
		@include transition(all, 1s);

		&-disabled {
			opacity: 0;
		}

		svg {
			width: 100%;
			height: auto;
		}

		&-left {
			left: $G-default;
			transform: translateX(-250%);
		}

		&-right {
			right: $G-default;
			transform: translateX(250%);
		}
	}

	&_panel {
		position: absolute;
		left: 0;
		top: 0;
		min-width: 100%;
		height: 100%;
		z-index: $ZI-menuPanel;
		visibility: hidden;
		overflow: auto;
		transform: translateY(-100%);
		background-color: #ffffff;

		@include breakpoint(xs) {
			overflow: hidden;
		}
	}

	&_panelInner {
		display: flex;
		gap: 80px;
		flex-wrap: wrap;
		width: calc(100% - 80px);
		margin: 100px 40px;
		transform: translateY(-20%);

		@include breakpoint(lt-lg) {
			gap: 40px;
		}

		@include breakpoint(xs) {
			flex-wrap: nowrap;
			margin: 0 0 0 15vw;
			height: 100%;
			align-items: center;
			gap: 0;
		}
	}

	&_item {
		flex: 0 0 calc(20% - 64px);
		color: #ffffff;
		cursor: pointer;
		transition: transform 0.3s ease;
		position: relative;
		//margin-bottom: 3rem;
		transform: scale(1);

		@include breakpoint(lt-lg) {
			flex: 0 0 calc(20% - 32px);
		}

		@include breakpoint(fullhd) {
			flex: 0 0 calc(16% - 55px);
		}

		@include breakpoint(xs) {
			flex: 0 0 calc(70vw);
			margin-bottom: 0;
			pointer-events: none;
			transform: scale(0.75);

			&-active {
				transform: scale(1);
				pointer-events: auto;

				.menu_item_image {
					transform: scale(1); // contre balance le sclae de la card
				}
			}
		}

		&-dark {
			color: #000000;
		}

		&_content {
			text-align: center;
			position: relative;
			box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.3);
			height: 100%;
		}

		&_imageWrapper {
			aspect-ratio: 1/1;
			position: relative;
			overflow: hidden;
		}

		&_image {
			background-position: center bottom;
			background-repeat: no-repeat;
			background-size: cover;
			transition: transform 0.6s ease;
			width: 100%;
			height: 100%;
			transform: scale(1); // contre balance le sclae de la card
			transform-origin: bottom center;

			@include breakpoint(xs) {
				width: 100vw;
				height: dvh(50);
				position: absolute;
				bottom: 0;
				left: -15vw;
				transform: scale(1.25);
				background-position: center center;
			}
		}

		&_layout {
			position: absolute;
			width: 100%;
			left: 0;
			top: 0;
			aspect-ratio: 1/1;
		}

		&_label {
			position: relative;
			font-family: $F-Montserrat;
			//letter-spacing: 0.05em;
			color: currentColor;
			display: block;
			text-transform: initial;
			font-weight: $FW-bold;
			padding: 2.5rem;
			aspect-ratio: 1/1;

			@include breakpoint(sm) {
				font-size: 2.5rem;
				padding: 2rem 2rem 6rem 2rem;
			}

			span {
				display: block;
				font-size: 3rem;

				@include breakpoint(sm) {
					font-size: 2.25rem;
				}

				&:first-child {
					font-size: 2.5rem;
					font-weight: $FW-medium;
					margin-bottom: 2.5rem;

					&:empty {
						margin-bottom: 0;
					}

					@include breakpoint(sm) {
						font-size: 1.65rem;
						margin-bottom: 1.875rem;
					}

				}

				&.menu_item_tag {
					position: absolute;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					gap: 1rem;
					bottom: 0;
					padding: 2rem;
					left: 50%;
					transform: translateX(-50%);

					span {
						font-size: 2.5rem;
						font-weight: $FW-medium;
						white-space: nowrap;
						@include breakpoint(sm) {
							font-size: 1.65rem;
						}
					}

					svg {
						width: 2rem;
						fill: currentColor;
					}
				}
			}
		}

		&_readingtime {
			position: absolute;
			bottom: -3rem;
			left: 0;
			right: 0;
		}

		&-imageBottom {
			.menu_item_image {
				@include breakpoint(ht-xs) {
					background-position: center bottom !important;
				}
			}
		}

		&[data-segment="edito"],
		&[data-segment="editorial"],
		&[data-segment="flax-fibre-future"],
		&[data-segment="lin-fibre-du-futur"] {
			.menu_item_image {

				@include breakpoint(xs) {
					width: 100%;
					height: 100%;
					left: 0;
					top: 0;
					background-size: cover;
				}
			}
		}
	}

	&_transition {
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		z-index: $ZI-menuPanel + 1;
		height: dvh(100);
		pointer-events: none;
		opacity: 0;
		text-align: center;
		transition: opacity 0.5s linear;

		&_img {
			height: 50%;
			background-size: cover;
			background-position: center center;
			background-repeat: no-repeat;

			@include breakpoint(xs) {
				clip-path: polygon(15% 35%, 85% 35%, 85% 100%, 15% 100%);
			}

			@include breakpoint(sm) {
				width: 50%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				transform: translateX(-100%);
			}
		}

		&_text {
			@extend .menu_item_label;
			height: 50%;
			aspect-ratio: auto;
			background: tomato;
			overflow: hidden;

			@include breakpoint(xs) {
				clip-path: polygon(15% 0%, 85% 0%, 85% 65%, 15% 65%);
			}

			@include breakpoint(sm) {
				width: 50%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				transform: translateX(-100%);
				padding: 9rem 12rem 6rem 6rem;
			}

			span {
				width: calc(70vw - 5rem);
				margin: 0 auto;
				display: block;

				@include breakpoint(sm) {
					//display: none;
					width: auto;
					margin: 0;
					text-align: left;

					&:first-child {
						font-size: 3.2rem;
						margin-bottom: 2.5rem;
					}
					&:last-child {
						font-size: 5.5rem;
						margin-top: 3rem;
					}
				}
			}
		}

		&.-visible {
			opacity: 1;
		}
	}


	&-isOpen {
		.menu_nav {
			transform: translateX(0);
		}
	}
}

</style>
